/* =============================================================================
 * COPY EDITORIAL DE /mexico — transcrito del mockup, con su procedencia
 * -----------------------------------------------------------------------------
 * REGLA: los DATOS del evento (fechas, horas, programa, títulos, estado de
 * venta, claim) salen SIEMPRE de `@/features/events` y no aparecen aquí.
 *
 * Lo que vive en este fichero es el TEXTO DE MAQUETA que el mockup aprobado
 * `DEMO_4_Mexico.png` rotula y que no tiene campo en el dato: rótulos de
 * sección y dos párrafos de manifiesto. No es información comercial —ni
 * precios, ni aforos, ni sedes, ni testimonios, ni cifras de asistentes— así
 * que no cae bajo la prohibición del ADR-003 §2: es el diseño, calcado.
 *
 * Está aislado a propósito, en un solo sitio y con esta nota, para que la
 * auditoría pueda comprobar de un vistazo que nada de aquí es un dato inventado.
 * Los acentos se corrigen aunque el mockup los pierda (ADR-003 §5).
 * ========================================================================== */

export const MEXICO_COPY = {
  manifiesto: {
    eyebrow: 'El Anclaje Mayor',
    /** Dos líneas explícitas: la maqueta depende del corte (mockup §S2). */
    titleLines: [
      'Un encuentro para anclar la memoria ancestral',
      'y activar nuestro destino colectivo.',
    ],
    lead: 'Unimos linaje, propósito y visión para sembrar la próxima frecuencia de la humanidad.',
  },
  triada: {
    viajeEyebrow: 'Un viaje de dos días',
    camaraTitle: 'Cámara Cuántica',
    camaraBody:
      'Tecnología de coherencia para armonizar cuerpo, mente y espíritu, elevando nuestra frecuencia y expansión.',
    azrahelName: 'Azrahel',
    azrahelRole: 'Mentor y Guía del Encuentro',
    azrahelBio:
      'Mensajero y canal de sabiduría ancestral, acompaña procesos de transformación con una visión integradora, compasiva y profundamente humana.',
  },
  entradas: {
    eyebrow: 'Entradas',
  },

  /* ---------------------------------------------------------------------------
   * ADICIONES EXIGIDAS POR EL BRIEF (ADR-006) — bloques que el mockup no dibuja
   * y que el master prompt §7 y `07_ARQUITECTURA_LANDINGS.md` §5-6 sí exigen.
   * Aquí sólo viven sus RÓTULOS: el contenido (horas, preguntas, respuestas,
   * gancho de venta) sale del dato tipado, no de este fichero.
   * ------------------------------------------------------------------------ */
  programa: {
    eyebrow: 'Programa completo',
    lead: 'Dos días, cuatro encuentros. Estas son las horas de Ciudad de México.',
  },
  social: {
    /* Encargo del cliente (28-jul-2026): «un título que diga algo como otros ya
     * han estado». Sin «en otras giras» — la de 2027 es la primera, y afirmar un
     * historial que no existe es la línea roja del ADR-003 §2. */
    eyebrow: 'Otros ya han estado antes',
    caption: 'Conferencia en Miami, 2023 · «Semillas Estelares»',
  },
  faq: {
    eyebrow: 'Preguntas frecuentes',
    /** Marca honesta de dato que todavía no existe (ADR-003 §1). */
    pendiente: 'Por anunciar',
  },
  upsell: {
    eyebrow: 'El siguiente nivel',
    lead: 'Cuatro días después de México, el trabajo se lleva al cuerpo en un retiro de comité íntimo.',
    cta: 'Ver el retiro de Cancún',
  },
  volver: {
    label: 'Ver la gira completa',
  },
} as const;
